// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'regenerator-runtime/runtime'
import Vue from 'vue'
// import Meta from 'vue-meta'
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'
import VueLodash from 'vue-lodash'
import VuePikaday from './helpers/pickadayHelpers'
import VuePikadayBooking from './helpers/pickadayBooking'
import VuePikadayReport from './helpers/pickadayReport'
import VuePikadayProfessionalRegister from './helpers/pickadayProfessionalRegister'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import VueSweetAlert from 'vue-sweetalert'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import BootstrapVue, { BModal, BPopover } from 'bootstrap-vue'
import IcFirebaseUploader from 'ic-firebase-uploader'
import MQ from 'vue-match-media/src'
import MultiDatesCalendar from './components/booking/MultiDatesCalendar'
import ProfessionalMultiDatesCalendar from './components/booking/ProfessionalMultiDatesCalendar'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate'
import VueCarousel from 'vue-carousel'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import i18n from './helpers/i18nHelpers'
import lodash from 'lodash'
import moment from 'moment-timezone'
import vueFb from './helpers/facebookSdk'
import linkify from 'vue-linkify'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueHtml2Canvas from 'vue-html2canvas'
import VueGtag from 'vue-gtag'
import Snackbar from 'vuejs-snackbar'
import Sticky from 'vue-sticky-directive'
import Tinybox from 'vue-tinybox'
import VueCountryCode from 'vue-country-code'
import OtpInput from '@bachdgvn/vue-otp-input'

// Import Helpers for filters
import {
  bankTransferDurationText,
  calculatePriceWithDiscount,
  count,
  cleaningDuration,
  credits,
  currency,
  currencyNoDecimal,
  declinedReason,
  discountValue,
  distance,
  domain,
  duration,
  firstName,
  internationalCode,
  myPlace,
  multiLangName,
  numberWithCommas,
  joinedDate,
  onlyTime,
  orderPaymentData,
  orderStatus,
  orderAdditionalHours,
  prettyDate,
  prettyOnlyDate,
  prettyOnlyMonthYear,
  prettyOnlyDateBE,
  prettyNumber,
  professionalJobStatus,
  ratingStar,
  replaceUrl,
  responseTime,
  serviceCost,
  reviewDurationText,
  serviceParentName,
  serviceRequestPaymentStatus,
  serviceRequestPaymentType,
  shortDate,
  shortText,
  stripSlashes,
  subscriptionStartDate,
  summaryCleaningDate,
  timeSpan,
  totalPriceWithDiscount,
  transportationTypeIcon, accounting, accountingNoDecimal, monthTH
} from './filters'

import App from './App'
import { routes } from './routes'
import store from './store/store'

// Set initial language for moment
moment.locale('th')
moment.tz.setDefault('Asia/Bangkok')

// JS Helpers VuePikaday & Initial Firebase
Vue.component(VueQrcode.name, VueQrcode)
Vue.component('b-modal', BModal)
Vue.component('b-popover', BPopover)
Vue.component('multi-dates-calendar', MultiDatesCalendar)
Vue.component('professional-multi-dates-calendar', ProfessionalMultiDatesCalendar)
Vue.component('ic-firebase-uploader', IcFirebaseUploader)
Vue.component('snackbar', Snackbar)
Vue.component('Tinybox', Tinybox)
Vue.component('v-otp-input', OtpInput)
Vue.directive('pikaday', VuePikaday)
Vue.directive('pikadayBooking', VuePikadayBooking)
Vue.directive('pikadayReport', VuePikadayReport)
Vue.directive('pikadayProfessionalRegister', VuePikadayProfessionalRegister)
Vue.directive('linkified', linkify)

// Clipboard logic
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueHtml2Canvas)
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(VueCarousel)
Vue.use(MQ)
Vue.use(VueScrollTo)
Vue.use(VeeValidate)
Vue.use(BootstrapVue)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(ToggleButton)
Vue.use(VueCookies)
Vue.use(Sticky)
Vue.use(VueCountryCode)
Vue.use(vueFb, {
  appId: '1138048446254453',
  autoLogAppEvents: true,
  xfbml: true,
  version: 'v3.2'
})
// Vue.use(Meta, {
//   tagIDKeyName: 'vmid',
//   refreshOnceOnNavigation: true
// })
Vue.use(VueMeta, {
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

// Import Install and register helper items
Vue.filter('bankTransferDurationText', bankTransferDurationText)
Vue.filter('calculatePriceWithDiscount', calculatePriceWithDiscount)
Vue.filter('count', count)
Vue.filter('cleaningDuration', cleaningDuration)
Vue.filter('credits', credits)
Vue.filter('currency', currency)
Vue.filter('currencyNoDecimal', currencyNoDecimal)
Vue.filter('declinedReason', declinedReason)
Vue.filter('discountValue', discountValue)
Vue.filter('distance', distance)
Vue.filter('domain', domain)
Vue.filter('duration', duration)
Vue.filter('firstName', firstName)
Vue.filter('internationalCode', internationalCode)
Vue.filter('joinedDate', joinedDate)
Vue.filter('multiLangName', multiLangName)
Vue.filter('myPlace', myPlace)
Vue.filter('numberWithCommas', numberWithCommas)
Vue.filter('onlyTime', onlyTime)
Vue.filter('orderPaymentData', orderPaymentData)
Vue.filter('orderStatus', orderStatus)
Vue.filter('prettyDate', prettyDate)
Vue.filter('prettyOnlyDate', prettyOnlyDate)
Vue.filter('prettyOnlyMonthYear', prettyOnlyMonthYear)
Vue.filter('prettyOnlyDateBE', prettyOnlyDateBE)
Vue.filter('prettyNumber', prettyNumber)
Vue.filter('professionalJobStatus', professionalJobStatus)
Vue.filter('ratingStar', ratingStar)
Vue.filter('replaceUrl', replaceUrl)
Vue.filter('responseTime', responseTime)
Vue.filter('reviewDurationText', reviewDurationText)
Vue.filter('serviceCost', serviceCost)
Vue.filter('serviceParentName', serviceParentName)
Vue.filter('serviceRequestPaymentStatus', serviceRequestPaymentStatus)
Vue.filter('serviceRequestPaymentType', serviceRequestPaymentType)
Vue.filter('shortDate', shortDate)
Vue.filter('shortText', shortText)
Vue.filter('stripSlashes', stripSlashes)
Vue.filter('subscriptionStartDate', subscriptionStartDate)
Vue.filter('summaryCleaningDate', summaryCleaningDate)
Vue.filter('timeSpan', timeSpan)
Vue.filter('totalPriceWithDiscount', totalPriceWithDiscount)
Vue.filter('transportationTypeIcon', transportationTypeIcon)
Vue.filter('accounting', accounting)
Vue.filter('accountingNoDecimal', accountingNoDecimal)
Vue.filter('monthTH', monthTH)
Vue.filter('orderAdditionalHours', orderAdditionalHours)

// Resource logic
Vue.use(VueResource)
// Vue.http.options.root = 'https://beneat.co/api-test'
let url = 'https://lumen.beneat.co'
if (window.location.hostname === 'localhost' || window.location.hostname === 'internal-test.beneat-test.com' || window.location.hostname === 'customer.beneat-test.com') {
  // url = 'https://beneat-test.com'
  // url = 'https://lumen-docker.beneat-test.com'
}

Vue.http.options.root = url
axios.defaults.baseURL = url

Vue.http.interceptors.push((request, next) => {
  // Check Authorization before calling request APIs
  const headers = request.headers
  const removeAuthHeaders = request.url.includes('googleapis.com')
  if (removeAuthHeaders) {
    headers.delete('Access-Control-Allow-Headers')
    headers.delete('Authorization')
  } else {
    if (!headers.hasOwnProperty('Authorization')) {
      // Vue.http.headers.common['Authorization'] = store.state.auth.token
      headers.set('Authorization', 'Bearer ' + store.state.auth.token)
    }
  }
  next()
})

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  const headers = config.headers
  const removeAuthHeaders = config.url.includes('googleapis.com')
  if (removeAuthHeaders) {
    headers.delete('Access-Control-Allow-Headers')
    headers.delete('Authorization')
  }
  if (!headers.hasOwnProperty('Authorization') && (store.state.auth)) {
    headers['Authorization'] = 'Bearer ' + store.state.auth.token
  }
  return config
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

// Lazyload logic
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/img/unknown.png',
  loading: null,
  attempt: 1
})

// Routing logic
Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // Set to scroll top of page when changing route
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  var compareDate = moment(new Date(), 'DD/MM/YYYY HH:mm:ss')
  var startDate = moment('11/05/2023 22:30:00', 'DD/MM/YYYY HH:mm:ss')
  var endDate = moment('12/05/2023 01:01:00', 'DD/MM/YYYY HH:mm:ss')

  if (compareDate.isBetween(startDate, endDate) === true) {
    // console.log('is DEBUG 1')
    location.replace('https://beneat.co/inconvenience-maintenance')
    // next({ path: '/inconvenience-maintenance', replace: true })
    return
  }

  if (to.meta.requiresAuth && store.state.auth.token === null) {
    // console.log('is DEBUG 2')
    next({ path: '/' })
  } else {
    // console.log('is DEBUG 3')
    next()
  }

  // ถ้าเป็น route ที่ต้องการ token ของแม่บ้านเพื่อเข้าสู่หน้าต่างๆ แล้วไม่มีนั้นให้เด้งไปหน้า professional-login
  if (to.meta.requiresAuthProfessional && (store.state.auth.tokenProfessional === null || !store.state.auth.tokenProfessional || !store.state.auth.professional)) {
    store.dispatch('auth/LOGOUT_PROFESSIONAL')
    next({ name: 'Professional Login' })
  } else {
    next()
  }

  // ถ้าเป็น route ที่ต้องการ token ของ partner  ถ้าไม่มีให้เด้งไปหน้า login partner
  if (to.meta.requiresAuthPartner && (!store.state.authPartner.partner || !store.state.authPartner.token)) {
    store.dispatch('authPartner/LOGOUT')
    next({ name: 'Partner Login' })
  } else {
    next()
  }
})

// Vue Analytics config
Vue.use(VueGtag, {
  config: { id: 'G-70Y0VPJXVV' }
}, router)

// Vue.config.productionTip = false
// Sweet Alert
Vue.use(VueSweetAlert)

// Google Maps logic
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDtPvCf3Zm24yJP2_-n4VeAK7eP3caZcuI',
    // v: '3.26',
    libraries: 'places'
  }
})

Vue.config.productionTip = false

Vue.prototype.$lineTrack = (type) => {
  window._lt('send', 'cv', {
    type
  }, ['545d4b92-ff7d-4e1e-8796-9e690e2cfa5c'])
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1024px)'
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js